import * as React from 'react';
import styled from 'styled-components';
import moment from 'moment';

moment.locale('nb');
import { NewsArticle } from '../layout/NewsArticle';
import { SectionContact } from '../layout/SectionContact';
import { SectionServices } from '../layout/SectionServices';
import { Overlap } from '../layout/Overlap';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { SectionNewsCard } from '../layout/SectionNewsCard';
import { useParams } from 'react-router';
import { CoverImage } from '../layout/CoverImage';
import { getSeoImage, getSeoText } from '../../utils/seo/utils';

//GraphQL
import { useQuery } from '@apollo/client';
import { SINGLE_NEWS_QUERY } from '../../../client/__graphql__/queries/getSingleNews';
import { CONFIG_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';
import {
  NewsType,
  Query,
  QueryGetSingleNewsArgs,
  QueryGetPageConfigInputArgs,
} from '../../../client/types/generated/types';

export const NewsWrapper = styled.div``;
const ArticleWrapper = styled.div``;

type GetNews = Pick<Query, 'getSingleNews'>;
type GetNewsVariables = QueryGetSingleNewsArgs;

type GetConfig = Pick<Query, 'getNdPageConfig'>;
type GetConfigVariables = QueryGetPageConfigInputArgs;

const News: React.FC = () => {
  const params = useParams<{ urltag: string; slug: string }>();

  const { data, error, loading } = useQuery<GetNews, GetNewsVariables>(
    SINGLE_NEWS_QUERY,
    {
      skip: !params.slug,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          urltag: params?.urltag ? params.urltag : '',
          slug: params.slug,
          type: NewsType.Nybyggportal,
        },
      },
    }
  );

  const { data: config, loading: configLoading } = useQuery<
    GetConfig,
    GetConfigVariables
  >(CONFIG_ITEM, {
    skip: !params?.urltag,
    fetchPolicy: 'network-only',
    variables: { input: { urltag: params?.urltag } },
  });

  if (loading) {
    return null;
  }

  return (
    <>
      <Seo
        title={`Nyheter - PrivatMegleren - ${data?.getSingleNews?.title}`}
        image={
          data?.getSingleNews?.image ? data?.getSingleNews?.image : undefined
        }
        description={
          data?.getSingleNews?.ingress
            ? getSeoText(data?.getSingleNews?.ingress)
            : undefined
        }
      />
      <Page>
        <NewsWrapper>
          <CoverImage
            url={data?.getSingleNews?.image}
            type={data?.getSingleNews?.imageCategory}
          />
          <Overlap yPos={-70}>
            <ArticleWrapper>
              <NewsArticle
                date={moment(
                  data?.getSingleNews?.published,
                  'DD.MM.YYYY HH:mm:ss'
                ).format('DD.MM.YYYY')}
                title={data?.getSingleNews?.title}
                ingress={data?.getSingleNews?.ingress}
                info={data?.getSingleNews?.body}
              />
            </ArticleWrapper>
          </Overlap>
          {config?.getNdPageConfig?.showSubpageNews ? (
            <SectionNewsCard />
          ) : null}
          {config?.getNdPageConfig?.showSubpageServices ? (
            <SectionServices />
          ) : null}
          {config?.getNdPageConfig?.showSubpageContact ? (
            <SectionContact />
          ) : null}
        </NewsWrapper>
      </Page>
    </>
  );
};

export default News;
